export const slugify = (text) => {
  if (!text) return '';
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

export const deslugify = (slug) => {
  if (!slug) return '';
  return slug.replace(/-/g, ' ');
};